import { render, staticRenderFns } from "./GameEntries.vue?vue&type=template&id=6f213da3"
import script from "./GameEntries.js?vue&type=script&lang=js&external"
export * from "./GameEntries.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports